<template>
  <div
    class="header-train-open font-weight-light color-1-5"
    :style="`
      ${wbline_ids?`height: ${bl_height};`:`height: calc(${taktarea_count} * (var(--workpackage_height) + 8px) * var(--taktplan_zoom));`}
      `"
    >
    <slot/>
  </div>
</template>
<script>
  export default {
    props: ['taktarea_count', 'train_open', 'wbline_ids'],
    data: () => ({
      bl_height: '100px',
    }),
    created() {
      this.bl_height = `calc(${this.taktarea_count} * (var(--workpackage_height) + 8px) * var(--taktplan_zoom))`
    },
    mounted() {
      let self = this;
      if (self.wbline_ids) {
        setTimeout(function () {

          let height = 0;
          self.wbline_ids.forEach(id => {
            let wbline_el = document.getElementById(`wbline${id}`);
            if (wbline_el) {
              height+= wbline_el.clientHeight;
            }
          })
          self.bl_height = `${height}px`;
          // self.bl_height_update_key++
        }, 100);
      }
    },
    updated() {
      let self = this;
      if (self.wbline_ids) {
        setTimeout(function () {
          let height = 0;
          self.wbline_ids.forEach(id => {
            let wbline_el = document.getElementById(`wbline${id}`);
            if (wbline_el) {
              height+= wbline_el.clientHeight;
            }
          })
          self.bl_height = `${height}px`;
          // self.bl_height_update_key++
        }, 100);
      }
    },
    methods: {
    }
  }
</script>
<style>
  .header-train-open {
    position: sticky;
    display: flex;
    left: 0px;
    width: calc(var(--project_taktplan_spatial_header_width) * 1px * var(--taktplan_zoom));
    background-color: white;
    z-index: 6;
    writing-mode: vertical-lr;
    text-orientation: mixed;
    transform: rotate(180deg);
    text-overflow: clip;
    /* color: black; */
    text-align: center;
    overflow: hidden;
    cursor: pointer;
    /* border-style: solid;
    border-width: 1px 0px 0px 0px; */
    /* border-color: black; */
    align-items: center;
    justify-content: center;
    /* padding: 6px; */
    user-select: none;
    flex-shrink: 0;
  }
</style>
